import React, { useCallback, useEffect, useRef } from "react";
import MarkerSelected from 'assets/icons/markerSelected.png';
import MarkerIcon from 'assets/icons/marker.png';
import GreenMarker from 'assets/icons/NearBy.png';
import { useState } from "react";
import placeholder from "assets/images/result/placeholder.svg";
import star from "assets/icons/search/star.png";
import './map.scss';
import { useHistory, useLocation } from "react-router-dom";
import { updateDates } from "features/stay-details/stay-details.slice";
import { useAppDispatch } from "store/store";
export interface MapComponentProps {
    markerData: any;
    markerSelected?: any;
    type?: any;
}

const Map: React.FC<MapComponentProps> = ({ markerData, markerSelected, type }) => {
    const googleMapRef = useRef<any>(null);
    const history = useHistory();
    const location = useLocation();
    const [googleMap, setGoogleMap] = useState<any>(null);
    const [existingMarkers, setExistingMarker] = useState<any>([]);
    const [currentLocationMarker, setLocationMarker] = useState<any>([]);
    const createMarker = (markerObj: any) => {
        const { name, room_category_rating, rating_count, price, latitude, longitude, image, titleName} = markerObj;
        const infoBox = `<div id="info-box-wrap">
        <div id="img-wrap">
            <img src=${image || placeholder}  alt="info-im"/>
        </div>
        <div id="content-wrap">
        <h1>${ titleName || name}</h1>
        <p class="type">Apartment</p>
        <div class="card-rating">
            <span class="rating-value ${!room_category_rating ? 'rating-value-red' : (room_category_rating as number) < 2 ? 'rating-value-red' : (room_category_rating as number) > 3 ? 'rating-value-green' : 'rating-value-yellow'}">
              ${room_category_rating || 0} <img src=${star}></img>
            </span>
            <span className="rating-users">${rating_count !==0 ? `${rating_count}+ Rated` : ''}</span>
        </div>
        <h1>AED ${price?.daily_rate || 0}/Night</h1>
        </div>
    </div>`
        const marker: any = new window.google.maps.Marker({
            position: { lat: latitude, lng: longitude },
            map: googleMap,
            icon: {
                url: MarkerIcon,
                scaledSize: new window.google.maps.Size(50, 50)
            },
        });
        marker.id = markerObj.property_id;
        existingMarkers.push(marker);
        setExistingMarker(existingMarkers);
        const infowindow = new window.google.maps.InfoWindow({ content: infoBox });
        marker.addListener("mouseover", () => infowindow.open(googleMap, marker));
        marker.addListener('mouseout', () => {
            infowindow.close();
        });
        marker.addListener('click', () => {
            if (marker.selected) {
                marker.setIcon({ url: MarkerIcon });
                markerSelected({});
            } else {
                const alreadySelectedMarker = existingMarkers.find((markerItem: any) => {
                    return markerItem.selected;
                });
                if (alreadySelectedMarker) {
                    alreadySelectedMarker.selected = false;
                    alreadySelectedMarker.setIcon({ url: MarkerIcon });
                }
                marker.setIcon({ url: MarkerSelected });
                markerSelected(markerObj);
            }
            marker.selected = !!!marker.selected;
        });
        return marker;
    }

    const dispatch = useAppDispatch();
    const navigateToOther =(slug:any) => {
        dispatch(updateDates(false));
        history.push(`/stay-details/${slug}`, { from: location.pathname })
    }

    const drawMarker = useCallback((markerData: any) => {
        const { location, rating, name, image, price, distance, description} = markerData;
        let priceValue = price;
        let iconUrl = MarkerIcon;
        if (markerData.selected) {
            iconUrl = MarkerSelected;
        } else if (markerData.rating) {
            iconUrl = GreenMarker;
        }
        if (typeof price === 'object') {
            priceValue = price?.member?.daily_rate;
        }

        const infoBox = `<div id="info-box-wrap" class="stay-info">
        <div id="img-wrap" >
            <img ${(!markerData.selected && rating) ? 'id="info-bg-img"' : ''} src=${image || placeholder}  alt="info-im" />
        </div>
        <div id="content-wrap">
            <h1 ${(!markerData.selected && rating) ? 'id="info-title"' : ''} >${ name} </h1>
            <p class="type ${!rating && 'no-rating'}">Apartment</p>
            <div class="card-rating ${!rating && 'no-rating'}">
                <span class="rating-value ${!rating ? 'rating-value-red' : (rating as number) < 2 ? 'rating-value-red' : (rating as number) > 3 ? 'rating-value-green' : 'rating-value-yellow'}">
                <img src=${star}></img>${rating || 0}
                </span>
                <span class="rating-users">20+ Rated</span>
            </div>
            <h1 class="price ${!rating && 'no-rating'}">AED ${priceValue || 0}/Night</h1>
            <div class="attraction ${!rating ? 'show' : ''}">
                <p class="distance">${distance?.toFixed(0)} km from the property</p>
                <div class="text-info">${description}</div>
            </div>
            </div>
        </div>`
        const bounds = new window.google.maps.LatLngBounds();
        const marker: any = new window.google.maps.Marker({
            position: { lat: location.latitude, lng: location.longitude },
            map: googleMap,
            icon: {
                url: iconUrl,
                scaledSize: new window.google.maps.Size(50, 50)
            },
        });
        currentLocationMarker.push(marker);
        setLocationMarker(currentLocationMarker);
        marker && bounds.extend(marker.position);
        googleMap && googleMap.fitBounds(bounds);

        if (googleMap) {
            const zoomChangeBoundsListener =
                google.maps.event.addListenerOnce(googleMap, 'bounds_changed', (event: any) => {
                    if (googleMap.getZoom()) {
                        googleMap.setZoom(13);
                    }
                });
            setTimeout(() => { google.maps.event.removeListener(zoomChangeBoundsListener) }, 2000);
        }
        if (type !== 'contact-us') {
            google.maps.event.addListener(marker, 'click', function () {
                marker.infoWindow = new google.maps.InfoWindow();
                marker.infoWindow.setContent(infoBox);
                if (!marker.infoWindowOpen) {
                    const alreadyOpenedInfoWindow = currentLocationMarker.filter((markerItem: any) => {
                        return markerItem.infoWindowOpen === true;
                    });
                    if (alreadyOpenedInfoWindow.length) {
                        alreadyOpenedInfoWindow.forEach((item: any) => {
                            item.infoWindowOpen = false;
                            item.infoWindow?.close()
                        })
                    }
                    marker.infoWindow.open(googleMap, marker);
                } else {
                    marker.infoWindow?.close()
                }
                marker.infoWindowOpen = !!!marker.infoWindowOpen;
                googleMap && google.maps.event.addListener(marker.infoWindow, 'domready', function () {
                    if (!markerData.selected && rating) {
                        const imgEle = document.getElementById('info-bg-img');
                        imgEle?.addEventListener('click', () => {
                            navigateToOther(markerData.slug)
                        })
                        const titleEl = document.getElementById('info-title');
                        titleEl?.addEventListener('click', () => {
                            navigateToOther(markerData.slug)
                        })
                    }
                });
            })
        }
        googleMap && google.maps.event.addListener(googleMap, 'click', function (event: any) {
            const alreadyOpenedInfoWindow = currentLocationMarker.filter((markerItem: any) => {
                return markerItem.infoWindowOpen === true;
            });
            if (alreadyOpenedInfoWindow.length) {
                alreadyOpenedInfoWindow.forEach((item: any) => {
                    item.infoWindowOpen = false;
                    item.infoWindow?.close()
                })
            }
        });
        // eslint-disable-next-line
    }, [googleMap, type])

    const loopMarkerData = useCallback((data) => {
        setLocationMarker([]);
        data.forEach((markerData: any) => drawMarker(markerData));
    }, [drawMarker])



    const addMarkerToMap = useCallback(() => {
        setExistingMarker([]);
        const bounds = new window.google.maps.LatLngBounds();
        markerData.forEach((markerData: any) => {
            const marker: any = createMarker(markerData);
            marker && bounds.extend(marker.position);
        });
        googleMap && googleMap.fitBounds(bounds);
        if (googleMap && markerData.length <= 3) {
            const zoomChangeBoundsListener =
                google.maps.event.addListenerOnce(googleMap, 'bounds_changed', (event: any) => {
                    if (googleMap.getZoom()) {
                        googleMap.setZoom(13);
                    }
                });
            setTimeout(() => { google.maps.event.removeListener(zoomChangeBoundsListener) }, 2000);
        }
        //eslint-disable-next-line 
    }, [googleMap, markerData])

    useEffect(() => {
        setGoogleMap(initGoogleMap());
        // eslint-disable-next-line
    }, []);

    useEffect(() => {
        if (markerData?.length) {
            type === 'search-result' ? addMarkerToMap() : loopMarkerData(markerData);
        }
    }, [markerData, type, addMarkerToMap, loopMarkerData])

    // initialize the google map
    const initGoogleMap = () => {
        return new window.google.maps.Map(googleMapRef.current, {
            center: { lat: -34.397, lng: 150.644 },
            zoom: 8,
        });
    }

    return <div ref={googleMapRef} id="map" style={{ width: '100%', height: '100%' }} />
}

export default Map;